// extracted by mini-css-extract-plugin
export default {"page-content-container":"AppLayout_page-content-container__iqrYJ"};